<res-generic-grid [gridName]="gridName" [automationId]="automationId" [helpIndex]="helpIndex"
    [updateStatusType]="updateStatusType" [headerTemplate]="headerTemplate" [(isBusy)]="isBusy"
    [(isBusyMessage)]="isBusyMessage" [columnDefs]="columnDefs" [requestInfo]="requestInfo"
    [contextMenuOptions]="contextMenuOptions" [responseArrayCallback]="responseArrayCallback"
    [cellDoubleClickedCallback]="cellDoubleClickedCallback" [rowClassRules]="rowClassRules">
</res-generic-grid>
<ng-template #headerTemplate>
    <button type="button" class="secondary-button" (click)="openNewDataAreaModal()"
        [attr.data-automation-id]="automationId + '-new-button'" *ngIf="!hasDAViewOnlyPermission">
        <i class="fa fa-plus"></i>New Data Area ...
    </button>
</ng-template>